import React from 'react';
import { IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/pro-solid-svg-icons/faEllipsis';
import styles from './QuickViewButton.module.scss?module';
import clsx from 'clsx';

interface QuickViewButtonProps {
  onShowQuickView: () => void;
}

const QuickViewButton: React.FC<QuickViewButtonProps> = ({
  onShowQuickView,
}) => {
  return (
    <div className={clsx(styles.MenuWrapper)}>
      <IconButton
        aria-label="Product details"
        onClick={(event) => {
          event.stopPropagation();
          onShowQuickView();
        }}
        className={styles.MenuButton}
        size="small"
      >
        <FontAwesomeIcon icon={faEllipsis} />
      </IconButton>
    </div>
  );
};

export default QuickViewButton;
